export enum LOGIN_ERROR {
    NOT_AUTHORIZED = 'NotAuthorizedException: Incorrect username or password', // that's the only type of error, we get from cognito regarding username/password. it's part of the security concept
    PASSWORD_ATTEMTPS_EXCEEDED = 'NotAuthorizedException: Password attempts exceeded', // too many retries to login to cognito
    USER_NOT_CONFIRMED = 'UserNotConfirmedException',
    GENERAL = '' // no internet, cognito has an internal server error etc.
}
